module.exports = __webpack_public_path__ + "img/free-trial.c29937b9.png";